/**
 * HTTP errors thrown by @ag-ui/client's HttpAgent.
 * The SDK attaches `status` and `payload` to a plain Error —
 * there is no exported class, so we mirror the shape here.
 */
export interface HttpError extends Error {
  status: number;
  payload: unknown;
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof Error && 'status' in error && typeof error.status === 'number' && 'payload' in error;
}
